export default "__VITE_ASSET__3mF7i1nS__"